import { getTimezoneName } from 'shared/utils/dateUtils';
import type { DbTraceProperties } from '@hub/common';
import type {
  BrowserInfo,
  DeviceInfo,
  ProseInfo,
} from 'features/system-info/store/systemInfoSlice';

export const getTraceProperties = ({
  now,
  windowId,
  language,
  proseInfo,
  browserInfo,
  deviceInfo,
}: {
  now: Date;
  windowId: string;
  language: string;
  proseInfo: ProseInfo;
  browserInfo: BrowserInfo;
  deviceInfo: DeviceInfo;
}): Omit<DbTraceProperties, 'traceClientActionType'> => {
  return {
    traceClientBrowserLanguage: browserInfo.language,
    traceClientBrowserUserAgent: browserInfo.userAgent,
    traceClientDeviceId: deviceInfo.id,
    traceClientDeviceModel: deviceInfo.model,
    traceClientDeviceOperatingSystem: deviceInfo.operatingSystem,
    traceClientDeviceOsVersion: deviceInfo.osVersion,
    traceClientDevicePlatform: deviceInfo.platform,
    traceClientLanguage: language,
    traceClientProseVersion: proseInfo.version,
    traceClientWindowId: windowId,
    traceClientTimestamp: now.toISOString(),
    traceClientTimezoneName: getTimezoneName(),
    traceClientTimezoneOffset: now.getTimezoneOffset(),
    traceClientUiVersion: import.meta.env.PUBLIC_BUILD_TAG ?? 'unknown',
  };
};
